import { CompletionBehaviorTemplate } from "../completionBehaviorTemplate/completionBehaviorTemplate";

/**
 * Defines the flow that should be used to execute the comman,
 * e.g. show a confirmation dialog or a form for gathering parameters.
 * 
 */
export class FlowTemplate{

  /**
   * name - name of the flow
   */
  name: string | undefined;

  /**
   * settings - settings of the flow, object
   */
  settings: any | undefined;

  /**
   * completionBehavior - completion behavior of the flow: a completion behavior defines,
   * what should happen after the command was executed, e.g. a refetch, show a message or
   * redirect to another page. Each class that implements commands has to define a default
   * completion behavior.
   */
  completionBehavior: CompletionBehaviorTemplate | undefined;

  constructor(payload?: any) {
    if (payload) {
      this.name = payload.name;
      this.settings = payload.settings;
      if(payload.completionBehavior){
        this.completionBehavior = new CompletionBehaviorTemplate(payload.completionBehavior);
      }
    }
  }

}


